import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  open: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  headerRoot: {
    position: 'relative',
    padding: ({ open }) => (open ? '2rem' : '1.25rem 2rem')
  },

  toggleBtn: {
    position: 'absolute',
    top: '0.25rem',
    left: '0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    userSelect: 'none'
  },

  bodyRoot: {
    position: 'relative',
    padding: '2rem'
  },

  toggleRoot: {
    position: 'absolute',
    top: '0.5rem',
    left: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  toggle: {
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    minHeight: '30px',
    height: '30px',
    paddingInline: '1rem'
  }
}))

export default useStyles
